<section class="ml-28 mr-8 h-full">
  <div class="grid grid-cols-10 mt-5 mb-4 text-center">
    <label class="ml-4 flex justify-center col-span-1 font-semibold text-base">
      <img [src]="images.messages.info" alt="info" class="h-6 w-6 mr-2" />
      {{ literalService.get("messages.data.info", true) }}
    </label>
    <label class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.messages.affair" alt="subject" class="h-6 w-6 mr-2" />
      {{ literalService.get("messages.data.subject", true) }}
    </label>
    <label class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.messages.from" alt="from" class="h-6 w-6 mr-2" />
      {{ literalService.get("messages.data.from", true) }}
    </label>
    <label class="flex justify-center col-span-3 font-semibold text-base">
      <img [src]="images.messages.receiver" alt="receiver" class="h-6 w-6 mr-2" />
      {{ literalService.get("messages.data.receiver", true) }}
    </label>
    <label class="flex justify-center col-span-2 font-semibold text-base">
      <img [src]="images.messages.date" alt="date" class="h-6 w-6 mr-2" />
      {{ literalService.get("messages.data.dateSent", true) }}
    </label>
  </div>
</section>
<section>
  <div id="messagesContainer" class="scrollable-content h-[calc(100vh-310px)] ml-25 mr-5 px-3 mb-2 overflow-y-scroll" >
    @if (!messages()!.isFetchingMessages) {
      @for (message of messages()!.value; track $index) {
        <a 
          id="{{ `messages${message.id}` }}"
          class="messageRow border rounded pt-2 pb-2 grid grid-cols-10 justify-center items-center mb-4"
          href="{{ `/message/${message.id}` }}"
          (click)="$event.preventDefault()"
        >
          <div class="flex justify-center cursor-pointer col-span-1" (click)="showMessageDetail(message.id!)">
            <div class="mr-2">
              @if (message.successful) {
                <img [src]="images.messages.successMessageSent" alt="successMessage" class="h-6 w-6" />
              } 
              @else {
                <img [src]="images.messages.failedMessageSent" alt="failedMessage" class="h-6 w-6" />
              }
            </div>
            <div>
              @if (message.channels && message.channels.length > 1) {
                <img [src]="images.messages.channel.multiple" alt="multipleChannel" class="h-6 w-6" />
              }
              @else if (message.channels.includes(MessageChannel.EMAIL)) {
                <img [src]="images.messages.channel.email" alt="emailChannel" class="h-6 w-6" />
              }
              @else if (message.channels.includes(MessageChannel.PUSH_NOTIFICATION)) {
                <img [src]="images.messages.channel.pushNotification" alt="pushChannel" class="h-6 w-6" />
              }
              @else if (message.channels.includes(MessageChannel.SMS)) {
                <img [src]="images.messages.channel.sms" alt="smsChannel" class="h-6 w-6" /> 
              }
            </div>
          </div>
          <label [id]="`subject-${message.id}`" class="truncate pr-3 pl-3 col-span-2 text-base cursor-pointer" [tooltip]="utilsService.visibleTooltip(`subject-${message.id}`) ? message.subject! : ''" [visibleTooltip]="utilsService.visibleTooltip(`subject-${message.id}`)" [position]="TooltipPosition.DYNAMIC" (click)="showMessageData(message.id!)">
            {{ message.subject }}
          </label>
          <label [id]="`from-${message.id}`" class="truncate pr-3 pl-3 col-span-2 text-base cursor-pointer" [tooltip]="(utilsService.visibleTooltip(`from-${message.id}`) && message.sender) ? message.sender! : ''" [visibleTooltip]="utilsService.visibleTooltip(`from-${message.id}`)" [position]="TooltipPosition.DYNAMIC" (click)="showMessageData(message.id!)">
            {{ message.sender }}
          </label>
          <label [id]="`to-${message.id}`" class="truncate pr-3 pl-3 col-span-3 text-base cursor-pointer" [tooltip]="(utilsService.visibleTooltip(`to-${message.id}`) && message.receiverName) ? message.receiverName! : ''" [visibleTooltip]="utilsService.visibleTooltip(`to-${message.id}`)" [position]="TooltipPosition.DYNAMIC" (click)="showMessageData (message.id!)">
            {{ literalService.get(`messages.receiver.${message.receiver!.toLowerCase()}`, true) }} - {{ message.receiverName }}
          </label>
          <label [id]="`dateSent-${message.id}`" class="truncate pr-3 pl-3 col-span-2 text-base cursor-pointer" (click)="showMessageData(message.id!)">
            {{ (message.dateTime| date: 'dd/MM/yyyy') || '-' }}
          </label>
        </a>
      }
    } @else {
      <ngx-skeleton-loader [count]="messages()?.pagination?.size || 10" appearance="line" [theme]="{ 'height': '40px' }"></ngx-skeleton-loader>
    }
  </div>
</section>